module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "comments-items"
  }, [_c('div', {
    staticClass: "detail-header",
    on: {
      "click": function($event) {
        return _vm.toActivityDetail(_vm.content)
      },
      "touchstart": function($event) {
        return _vm.showDeleteButton()
      },
      "touchend": _vm.emptyTime
    }
  }, [_c('div', {
    staticClass: "user-face"
  }, [_c('img', {
    attrs: {
      "src": _vm.content.user_face,
      "alt": "",
      "srcset": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-names"
  }, [_vm._v(_vm._s(_vm.content.user_name))]), _vm._v(" "), _c('div', {
    staticClass: "look-info"
  }, [_vm._v(_vm._s(_vm.content.create_time_ago))])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "activity-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.content.content)
    },
    on: {
      "click": function($event) {
        return _vm.toActivityDetail(_vm.content)
      }
    }
  }), _vm._v(" "), (_vm.content.pics.length > 0) ? _c('div', {
    staticClass: "activity-imgs"
  }, [_c('img', {
    attrs: {
      "src": _vm.content.pics_url[0],
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.onImageView(_vm.content.pics_url[0])
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "activity-detail-bottom"
  }, [_c('div', {
    staticClass: "activity-place-box"
  }), _vm._v(" "), _c('div', {
    staticClass: "release-time"
  }, [_c('span', [_vm._v(_vm._s(_vm.content.create_time_ago))]), _vm._v(" "), _c('span', {
    staticClass: "release-time-right"
  }, [(_vm.commentShow) ? _c('span', {
    ref: "comment",
    staticClass: "icon-zan-comment-box"
  }, [(_vm.content.is_zan) ? _c('img', {
    staticClass: "icon-zan0",
    attrs: {
      "src": require("../../assets/images/activity/icon-zan-1@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.onRemoveZan
    }
  }) : _c('span', {
    on: {
      "click": _vm.onAddZan
    }
  }, [_c('img', {
    staticClass: "icon-zan1",
    attrs: {
      "src": require("../../assets/images/activity/icon-zan-0@2x.png"),
      "alt": ""
    }
  }), _vm._v("赞\n            ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    },
    on: {
      "click": _vm.onSendComment
    }
  }, [_c('img', {
    staticClass: "icon-zan2",
    attrs: {
      "src": require("../../assets/images/activity/icon-list-comment@2x.png"),
      "alt": ""
    }
  }), _vm._v("评论\n            ")])]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "icon-shuo-comment",
    attrs: {
      "src": require("../../assets/images/activity/icon-shuo-comment@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.onComment
    }
  })])])]), _vm._v(" "), (_vm.content.zan_list.length > 0 || _vm.content.comment_list.length > 0) ? _c('div', {
    staticClass: "comments-detail"
  }, [_c('div', {
    staticClass: "comments-detail-top"
  }), _vm._v(" "), (_vm.content.zan_list.length > 0) ? _c('div', {
    staticClass: "zan-box",
    style: (_vm.content.comment_list.length > 0 ? 'border-bottom: 1px solid #e6e6e6;' : '')
  }, [_c('span', {
    staticClass: "zan-num"
  }, [_vm._v(_vm._s(_vm.content.zan_list.length) + "赞")]), _vm._v(" "), _vm._l((_vm.content.zan_list), function(zan, i) {
    return _c('img', {
      key: i,
      staticClass: "user-zan-face",
      attrs: {
        "src": zan.user_face,
        "alt": ""
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.content.comment_list), function(item, i) {
    return (i < 10) ? _c('div', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.onToUserComment(item)
        },
        "touchstart": function($event) {
          return _vm.showCommentDeleteButton(item, i)
        },
        "touchend": _vm.emptyTime
      }
    }, [(item.to_user_name == null) ? _c('div', {
      staticClass: "user-comments",
      staticStyle: {
        "padding": "5px 0 5px 10px"
      }
    }, [_c('span', {
      staticClass: "comments-user-name"
    }, [_vm._v(_vm._s(item.user_name))]), _vm._v(" :\n          "), _c('span', {
      staticClass: "comments-user-desc"
    }, [_vm._v(_vm._s(item.content))])]) : _c('div', {
      staticClass: "user-reply-comments",
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_c('span', {
      staticClass: "comments-user-name"
    }, [_vm._v(_vm._s(item.user_name))]), _vm._v(" 回复\n          "), _c('span', {
      staticClass: "comments-user-name"
    }, [_vm._v(_vm._s(item.to_user_name))]), _vm._v(" :\n          "), _c('span', {
      staticClass: "comments-user-desc"
    }, [_vm._v(_vm._s(item.content))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.content.comment_list.length > 10) ? _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("...")]) : _vm._e()], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5536bfa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activity/Activity5.vue
// module id = 1584
// module chunks = 0